import { render, staticRenderFns } from "./CartForgotPassword.vue?vue&type=template&id=0dc64d02"
import script from "./CartForgotPassword.vue?vue&type=script&lang=js"
export * from "./CartForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports